import { render, staticRenderFns } from "./RoleCertificateRequirementsSidebar.vue?vue&type=template&id=0f5f702c&scoped=true"
import script from "./RoleCertificateRequirementsSidebar.vue?vue&type=script&lang=js"
export * from "./RoleCertificateRequirementsSidebar.vue?vue&type=script&lang=js"
import style0 from "./RoleCertificateRequirementsSidebar.vue?vue&type=style&index=0&id=0f5f702c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f702c",
  null
  
)

export default component.exports